import type { AxiosInstance } from 'axios';
import { getEnv } from '@/common/utils/getEnv';

const USERS_FILTER_MAX_IN_ARGS = 30;

export const fetchUsersByIds = async <TUser = Record<string, unknown>>(
  httpClient: AxiosInstance,
  userIds: string[],
): Promise<TUser[]> => {
  const uniqueUserIds = [...new Set(userIds)];
  const chunks: string[][] = [];
  for (let i = 0; i < uniqueUserIds.length; i += USERS_FILTER_MAX_IN_ARGS) {
    chunks.push(uniqueUserIds.slice(i, i + USERS_FILTER_MAX_IN_ARGS));
  }
  const responses = await Promise.all(
    chunks.map(async (chunk) => {
      const { data } = await httpClient.get(`${getEnv().apiBaseUrl}/api/users/v1`, {
        params: {
          limit: USERS_FILTER_MAX_IN_ARGS,
          filter: JSON.stringify({ field: 'id', operator: 'in', value: chunk }),
        },
      });
      return (data?.items ?? []) as TUser[];
    }),
  );
  return responses.flat();
};
